import { BrandConfig } from '@/Ship/Configs/BrandConfig'

export interface BrandMarkProps {
    /** Сторона знака в пікселях. */
    size?: number
    className?: string
}

/**
 * Знак бренду — сайдбар, прелоадер, екран входу (`SPEC-014` §1.5, ADR 048).
 *
 * Картинку дає активний профіль. Знак Астерікса — растрова вирізка з логотипа
 * легасі без прозорості (Q14.2): на темному тлі вийшов би білий прямокутник із
 * гострими кутами, тому такий знак стоїть на білій плашці з радіусом 8 px,
 * однаковій в обох темах (`mark.plate`). Прозорому знаку плашка не потрібна.
 */
export const BrandMark = ({ size = 32, className }: BrandMarkProps) => (
    <span
        className={className}
        style={{
            display: 'inline-flex',
            flexShrink: 0,
            width: size,
            height: size,
            borderRadius: 8,
            overflow: 'hidden',
            ...(BrandConfig.mark.plate ? { background: 'var(--ant-color-white, #ffffff)' } : {}),
        }}
    >
        <img
            src={BrandConfig.mark.src}
            alt={BrandConfig.name}
            width={size}
            height={size}
            style={{ display: 'block', width: size, height: size }}
        />
    </span>
)
